import request from '@/common/request'

class UFService {
  getAll() {
    return request.get('/ufs')
  }
}

export default new UFService()
